import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Courses() {
  return <section id="courses" className="py-24 bg-dark text-white overflow-hidden" data-id="element-52">
      <div className="container mx-auto px-6 md:px-12" data-id="element-53">
        {/* Mobile Title (visible only on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="md:hidden mb-8" data-id="element-54">
          <h2 className="font-heading text-4xl mb-4" data-id="element-55">Стань майстром</h2>
          <div className="w-12 h-px bg-accent" data-id="element-56"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-57">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 md:order-1" data-id="element-58">
            {/* Desktop Title (hidden on mobile) */}
            <div className="hidden md:block" data-id="element-59">
              <h2 className="font-heading text-4xl md:text-5xl mb-6" data-id="element-60">
                Стань майстром
              </h2>
              <div className="w-12 h-px bg-accent mb-8" data-id="element-61"></div>
            </div>

            <p className="text-gray-300 font-light leading-relaxed mb-8" data-id="element-62">
              Авторські курси для початківців та майстрів, які хочуть підвищити
              свою кваліфікацію. Навчання проходить у міні-групах, що гарантує
              індивідуальний підхід до кожного учня.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-63">
              {['80% практичних занять на моделях', 'Надання всіх необхідних інструментів та матеріалів', 'Сертифікат після успішного завершення', 'Підтримка та консультації після курсу'].map((item, i) => <li key={i} className="flex items-start" data-id="element-64">
                  <Check className="text-accent mr-3 mt-1 flex-shrink-0" size={18} data-id="element-65" />
                  <span className="text-gray-300 font-light text-sm" data-id="element-66">
                    {item}
                  </span>
                </li>)}
            </ul>

            <a href="#contact" className="inline-block px-8 py-4 bg-accent text-white text-sm font-medium tracking-wide hover:bg-accent-hover transition-colors" data-id="element-67">
              Записатися на курс
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[400px] md:h-[500px] order-1 md:order-2" data-id="element-68">
            <div className="w-full h-full bg-[#1A1A1A] border border-gray-800 flex items-center justify-center" data-id="element-69">
              <div className="text-center" data-id="element-70">
                <div className="w-16 h-16 mx-auto mb-4 border border-gray-700 rounded-full flex items-center justify-center" data-id="element-71">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-500" data-id="element-72">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-73"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5" data-id="element-74"></circle>
                    <polyline points="21 15 16 10 5 21" data-id="element-75"></polyline>
                  </svg>
                </div>
                <p className="text-sm text-gray-500 font-light tracking-widest uppercase" data-id="element-76">
                  Фото процесу навчання
                </p>
              </div>
            </div>
            <div className="absolute inset-0 border border-accent/30 m-6 pointer-events-none" data-id="element-77"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}